import { formatAmount } from 'src/utils/commonUtils';
import { IDisplayItems } from '../interfaces/EmiSchedule.type';
import { STATUS } from './EmiSchedule.component';

export enum enachMode {
  sms,
  whatsapp
}

export enum EnachSetupKinds {
  INITIAL_STATE,
  UPDATE_THROUGH_WHATSAPP,
  UPDATE_THROUGH_SMS,
  UPDATE_PHONE_NUMBER,
  CLOSE,
  BEFORE_API_CALL,
  API_CALL_SUCCESS
}

export const EMIBreakUpSubType = {
  PRINCIPAL: 'Principal',
  INTEREST: 'Interest',
  LATE_FEE: 'Late Fee',
  BOUNCE_FEE: 'Bounce Fee',
  PROCESSING_FEE: 'Processing Fee'
};

export const displayItems: Array<IDisplayItems> = [
  {
    header: 'Overdue amount',
    color: 'red',
    value: data => formatAmount(data.outstandingAmount?.amount, false)
  },
  {
    header: 'Current POS',
    color: 'black',
    value: data => formatAmount(data.outstandingPrincipal)
  },
  {
    header: `Overdue EMI`,
    color: 'black',
    value: data => data.unpaidDues,
    checkPluralization: true
  }
];

export enum OverdueMappings {
  interest = 'Interest',
  principal = 'Principal',
  lateFee = 'Late Fee',
  bounceFee = 'Bounce Fee',
  penalInterest = 'Penal Interest',
  heldBounceFee = 'Held Bounce Fee',
  heldLateFee = 'Held Late Fee',
  heldPenaltyCharges = 'Held Penalty Charges',
  penaltyCharges = 'Penalty Charges'
}

export enum CalculateOverdueKind {
  INITIAL_STATE,
  SET_DATE,
  CLOSE,
  BEFORE_API_CALL,
  API_ERROR,
  API_CALL_SUCCESS,
  INPUT_DATE_ERROR
}
export const NO_FEE_WAIVER_HISTORY = 'No Fee waiver history';
export const FEE_WAIVE_SUBMIT_MSG = 'Fee Waived and Payment link sent successfully.';
export const FEE_HOLD_SUBMIT_MSG = 'Fee Held and Payment link sent successfully.';
export const FEE_WAIVE_ERROR_MSG =
  'Something went wrong. Please refresh the page to update and check if the fee was waived under Waive Fee History.';

export const EMI_BREAKUP_SECTION = {
  BREAKUP: 'Breakup',
  AMOUNT: 'Amount',
  UNPAID: 'Unpaid'
};

export const PAYMENT_HISTORY_SECTION = {
  PAYMENT_AMOUNT: 'Payment Amount',
  PAID_ON: 'Paid On',
  PAYMENT_MODE: 'Payment Mode'
};

export const PAYMENT_HISTORY_ICON_FILL = {
  [STATUS.PAID]: '#0276FE',
  [STATUS.UNPAID]: '#D9D9D9'
};

export const ErrorTexts = {
  REQUIRED: 'Field cannot be empty',
  MAX: 'Enter a lower value',
  MIN: 'Enter a greater value'
};

export const EMI_CALENDAR_ACTIONS = {
  WAIVE_FEE: {
    label: 'Waive Fee',
    value: 'waiveFee'
  },
  EMI_BREAKUP: {
    label: 'EMI Breakup',
    value: 'emiBreakup'
  },
  REPAYMENT_DUE: {
    label: 'Repayment Due',
    value: 'repaymentDue'
  }
};
